import { GridsterWidget } from '../../vo/workingzone/gridster-widget';
import { TranslatableLabelVO } from '../../vo/common/translation/translatable-label.vo';
import { PhysicalTemplate, TranslatedEmb, WidgetEmb } from '@wizeoo/akm-message-lib';
import { WizMathUtils } from '@wizeoo/akm-core-lib';
import { IVo, entity, field } from '@wizeoo/akm-compute-lib';
import { Model } from '../..//model/model';

@entity('wizeoo.allkeyme.workingzone.message.PhysicalTemplate', 'VISION')
/** composition du physicalTemplate pour manipulation */
export class PhysicalTemplateVO implements IVo {
  
  private _source: PhysicalTemplate; // accesseur sur l'objet véritable
  public isFake: boolean = false; // objet en cours de création
  
  protected _model: Model = null;
  public get model(): Model {
    return this._model;
  }
  public set model(value: Model) {
      this._model = value;
  }
  
  constructor(model: Model, value?: PhysicalTemplate) {
    this._model = model;
    if (value != null) {
      this._source = value;
    } else {
      this._source = this.model.physicalTemplateEngine.newPhysicalTemplate();
      this.isFake = true;
    }
  }

  public get source(): PhysicalTemplate {
    return this._source;
  }
  public set source(src: PhysicalTemplate) {
    this._source = src;
    this._gridsters = null; // on oublie
  }

  public set uid(uid: string) {
    this._source.uid = uid;
  }
  public get uid(): string {
    return this._source.uid;
  }

  // Id technique
  public get id(): number {
    return this._source.id;
  }
  public set id(value: number) {
    this._source.id = value;
  }

  public set domain(domain: string) {
    this._source.domain = domain;
  }

  public get domain(): string {
    return this._source.domain;
  }

  /** accesseurs sur BusinessUnit */
  get businessUnitCode(): string {
    return this._source.businessUnitCode;
  }
  set businessUnitCode(value: string) {
    this._source.businessUnitCode = value;
  }

  /** accesseurs sur le code */
  @field('string')
  public set code(code: string) {
    this._source.code = code ? code.toUpperCase() : code;
  }
  public get code(): string {
    return this._source.code;
  }

  /** Libellé traductible */
  private _labelVO: TranslatableLabelVO;
  public get labelVO(): TranslatableLabelVO {
    if (!this._labelVO) {
      this._labelVO = this.model.localeEngine.newTranslatableVO(this, 'label');
    }
    return this._labelVO;
  }

  /** description en mode VO */
  private _descriptionVO: TranslatableLabelVO;
  public get descriptionVO(): TranslatableLabelVO {
    if (!this._descriptionVO) {
      this._descriptionVO = this.model.localeEngine.newTranslatableVO(this, 'description');
    }
    return this._descriptionVO;
  }

  /** accesseur sur libellé traduit */
  get trsLabel(): string {
    return this.model.localeEngine.translate(this.label, this.code);
  }

  /** accesseur sur desc traduit */
  get trsDesc(): string {
    return this.model.localeEngine.translate(this.description);
  }

  /** accesseurs sur deleted (logique) */
  @field('boolean')
  get deleted(): boolean {
    return this._source.deleted;
  }

  set deleted(value: boolean) {
    this._source.deleted = value;
  }

  set widget(values: WidgetEmb[]) {
    this._source.widgets = values;
  }
  get widget(): WidgetEmb[] {
    return this._source.widgets;
  }

  @field('TranslatedEmb')
  public set label(value: TranslatedEmb) {
    this._source.label = value;
  }
  public get label(): TranslatedEmb {
    return this._source.label;
  }

  @field('TranslatedEmb')
  public set description(value: TranslatedEmb) {
    this._source.description = value;
  }
  public get description(): TranslatedEmb {
    return this._source.description;
  }

  @field('string')
  public get visionCode(): string {
    return this._source.visionCode;
  }

  public set visionCode(pValue: string) {
    this._source.visionCode = pValue;
  }

  // TODO : détecter les changements sur les sous-collections
  @field('maintenanceFlag') // patch pour s'assurer de la demande de mise à jour sur contenu de steps
  public get maintenanceFlag(): string {
    return this._source.maintenanceFlag;
  }
  public set maintenanceFlag(value: string) {
    this._source.maintenanceFlag = value;
  }

  /** accesseurs sur le mode de rendu */
  @field('string')
  public set screenMode(value: string) {
    this._source.screenMode = value;
  }
  public get screenMode(): string {
    return this._source.screenMode;
  }

  @field('string')
  public get color(): string {
    return this.source.color;
  }
  public set color(value: string) {
    this.source.color = value;
  }  


  /* ################################################
              Accesseurs composites
     ################################################ */

  exists(): boolean {
    return !!this._source.id &&  this._source.id >= 0;
  }

  // les widgets avec le contrat d'interface gridster
  private _gridsters: GridsterWidget[] = null;

  public get widgets(): GridsterWidget[] {
    if(!this._gridsters) {
      this._gridsters = [];
      this.widget?.forEach((wid: WidgetEmb) => {
        this._gridsters.push(new GridsterWidget(this.model, wid));
      });
    }
    return this._gridsters;
  }

  public set widgets(values: GridsterWidget[]) {
    this._gridsters = values;
    // synchro des widgets (véritables)
    const wids: WidgetEmb[] = [];
    values.forEach((gwid: GridsterWidget) => {
      wids.push(gwid.source);
    });
    this.widget = wids;
    this.maintenanceFlag = WizMathUtils.createUUID(); // PATCH MAJ SUBCOLL
  }

  /** retourne vrai si au moins l'un des emplacements contient un contenu actif */
  public hasWidget(): boolean {
    let result: boolean = false;
    this.widgets.forEach((item: GridsterWidget) => {
      if (item.hasContent()) {
        result = true;
      }
    });
    return result;
  }
}
